const state = {
  title: '',
  content: null,
  isPopupActive: false,
  popupClasses: '',
  fullscreen: false,
};

const mutations = {
  setIsActive(state, isActive) {
    state.isPopupActive = isActive;
  },
  setContent(state, content) {
    state.content = content;
  },
  setTitle(state, title) {
    state.title = title;
  },
  setPopupClasses(state, popupClasses) {
    state.popupClasses = popupClasses;
  },
  setFullscreen(state, fullscreen) {
    state.fullscreen = fullscreen;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
